const state = {
  keys: new Map(),
  callbacks: new Map()
}

const events = ['keydown', 'keyup']

function handle (e) {
  state.keys.set(e.code, e.type === 'keydown')
  if (e.type === 'keyup' && state.callbacks.has(e.code)) {
    const callback = state.callbacks.get(e.code)
    callback(e)
  }
}

export function start () {
  events.forEach(event => window.addEventListener(event, handle))
}

export function stop () {
  events.forEach(event => window.removeEventListener(event, handle))
}

export function setKeyState (code, value) {
  state.keys.set(code, value)
}

export function isPressed (code) {
  return state.keys.get(code)
}

export function isReleased (code) {
  return !isPressed(code)
}

export function on (code, callback) {
  state.callbacks.set(code, callback)
}

export function off (code) {
  state.callbacks.delete(code)
}

export default {
  start,
  stop,
  on,
  off,
  isPressed,
  isReleased
}
